<template>
  <div>正在跳转...</div>
</template>

<script>
const axios = require("axios");
import store from "@/store";
import util from "../util";

export default {
  data() {
    return {};
  },

  beforeRouteEnter(to, from, next) {
    next(async (vm) => {
      // 初始化
      await vm.init();
      
      // 如果上一个页面不是当前页面（即初始化页面），就跳转回上一个页面；否则，跳转到登录页面
      if (from.path != to.path) {
        vm.$router.push(from.fullPath);
      } else {
        util.gotoLoginPage();
      }
    });
  },

  methods: {
    /**
     * 初始化
     */
    async init() {
      // 从服务器取得项目信息
      await this.loadProjectInfo();

      // 标记已完成初始化
      store.inited = true;

      // 将项目名称作为页面的title
      document.title = store.projectInfo.name;
    },

    /**
     * 从服务器取得项目信息
     */
    async loadProjectInfo() {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/getProjectInfo`,
          {}
        )
      ).data;
      if (resData.code > 0) {
        this.$message({
          message: resData.message,
          type: "error",
        });
        return;
      }

      // 将从服务器获取得的项目信息给保存下来
      store.projectInfo = resData.data;
    },
  },
};
</script>
